/**
 * @architecture-header 1
 * @layer module-ui
 * @domain settings-ai-assistant
 * @responsibility Host AST-F01's real assistant management UI inside the SET-F09 AI Assistant
 *   Settings pane -- placement only, no redesign of AST-F01's own states.
 * @state-owner AST-F01's own dataset store and mutations; this wrapper owns no state
 * @allowed-imports React; shared translator; modules/assistants public API
 * @forbidden direct API client; re-implementing AST-F01's list/editor UI
 * @public-api AiAssistantSettingsPage
 * @side-effects none of its own -- delegates entirely to AssistantSettingsPage
 * @tests AiAssistantSettingsPage.test.tsx
 */

import { AssistantSettingsPage } from '../../../modules/assistants';
import { useTranslator } from '../../../shared/model/use-workspace';
import './settings-ai-assistant.css';

export function AiAssistantSettingsPage({ mobile }: { mobile: boolean }) {
  const t = useTranslator();
  return (
    <section
      aria-label={t('AI Assistant')}
      className={`ai-assistant-settings-pane${mobile ? ' ai-assistant-settings-pane--mobile' : ' ai-assistant-settings-pane--desktop'}`}
    >
      <AssistantSettingsPage savePlacement="inline" />
    </section>
  );
}
